import React from "react";
import { Field, Label, Description } from "@headlessui/react";
import clsx from "clsx";
import ErrorMessage from "./ErrorMessage";

export default function FormField({
  label,
  description,
  id,
  errorMsg,
  className,
  children,
  ...restProps
}) {
  return (
    <Field className={clsx("tw-flex tw-flex-col", className)} {...restProps}>
      <Label className="tw-font-sans tw-text-lg tw-font-medium tw-ml-1" htmlFor={id}>
        {label}
      </Label>
      {description && (
        <Description className="tw-font-sans tw-text-md tw-ml-1">
          {description}
        </Description>
      )}
      {children}
      {errorMsg && <ErrorMessage errorMsg={errorMsg} />}
    </Field>
  );
}
